import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const HowItWorksSection = () => {
  const { t } = useLanguage();

  const steps = [
    { num: "01", title: t("how_step1_title"), desc: t("how_step1_desc") },
    { num: "02", title: t("how_step2_title"), desc: t("how_step2_desc") },
    { num: "03", title: t("how_step3_title"), desc: t("how_step3_desc") },
  ];

  return (
    <section id="how-it-works" className="calli-section relative overflow-hidden" data-testid="how-it-works-section">
      <div className="absolute inset-0 animated-gradient"></div>
      <div className="glow-orb w-[400px] h-[400px] bg-green-500/20 top-1/2 left-0 -translate-y-1/2"></div>
      
      <div className="calli-container relative z-10">
        <div className="text-center mb-16 space-y-4">
          <span className="calli-badge">🎯 {t("how_badge")}</span>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black">
            {t("how_title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="relative calli-glass rounded-3xl p-8 group hover:scale-105 transition-all duration-500"
              data-testid={`step-${index}`}
            >
              {/* Number */}
              <div className="text-8xl font-black gradient-text opacity-20 absolute top-4 right-4">
                {step.num}
              </div>
              
              <div className="relative z-10">
                <div className="w-16 h-16 mb-6 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-2xl flex items-center justify-center text-white text-2xl font-black shadow-lg shadow-orange-500/30">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">
                  {step.title}
                </h3>
                <p className="text-gray-400">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
